// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"32":"HomeView","68":"business","545":"aboutMe","557":"share","895":"download"}[chunkId] + "." + {"32":"bb9318ea","68":"9783a004","545":"6c498623","557":"5a0ce49d","895":"a6d4aa33"}[chunkId] + ".css";
};